import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { LoadingScreen } from "../components/LoadingScreen";

export function ProtectedRoute({
  children,
  requireAdmin = false,
  requireAdminOrManager = false,
}: {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireAdminOrManager?: boolean;
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen message="Preparando seu workspace" />;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (requireAdminOrManager && user.role !== "admin" && user.role !== "manager") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
